import { MessageCircle } from 'lucide-react';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Note } from '@/Domain/api/Conversation/dto/Note.dto';
import { sanitizeWithExternalLinks } from '@/Domain/helper/sanitize.helper';

type Props = {
  note: Note;
};

export const NoteItem = memo(({ note }: Props) => {
  const { t } = useTranslation('inbox_v2');

  return (
    <li
      data-testid="inbox-ai-note"
      className="grid grid-cols-[min-content_1fr] gap-3.5 p-4 border border-border text-foreground-subtle rounded-xl text-sm w-fit max-w-full self-center"
    >
      <MessageCircle className="mt-0.5 text-primary text-base size-4" />
      <div className="flex flex-col min-w-0">
        <p className="text-sm font-semibold text-foreground mb-1">{t('ai_note')}</p>
        <span
          data-testid="inbox-ai-note-description"
          className="break-words"
          dangerouslySetInnerHTML={{ __html: sanitizeWithExternalLinks(note.description) }}
        />
      </div>
    </li>
  );
});

NoteItem.displayName = 'NoteItem';
